import React from 'react';
import { Info } from 'lucide-react';

export const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center mb-6">
        <Info className="mr-2" size={32} />
        <h1 className="text-4xl font-bold">About This Template</h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="p-6">
          <p className="text-lg mb-4">
            This React application template is built with modern tools and best practices in mind.
            It includes everything you need to get started with a new project quickly.
          </p>

          <p className="text-lg mb-6">
            The template features Docker configuration for both development and production environments,
            automated setup scripts, Tailwind CSS for styling, and Lucide icons for beautiful UI elements.
          </p>

          <hr className="my-6 border-gray-200" />

          <h2 className="text-xl font-semibold mb-4">Tech Stack:</h2>

          <ul className="space-y-2 pl-5">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              React with React Router for navigation
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Tailwind CSS for utility-first styling
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Lucide icons for SVG icons
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Docker and Nginx for containerization and serving
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              GitHub integration for version control
            </li>
          </ul>

          <div className="mt-8 p-4 bg-blue-50 rounded-md">
            <h3 className="text-sm font-semibold mb-2">Why Tailwind CSS?</h3>
            <p>
              Tailwind CSS provides utility classes that let you build custom designs directly in your markup.
              It gives you complete control over your HTML structure and styling, enabling rapid development
              without the overhead of traditional CSS frameworks or UI libraries.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
